import React from 'react';
import { Link } from 'react-scroll';

const Button = ({ children, to, primary, outline, className = '', ...props }) => {
  const baseClasses = 'font-bold rounded-full text-lg transition duration-300';
  const primaryClasses = 'btn-primary text-white';
  const outlineClasses = 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900';

  const classes = `${baseClasses} ${primary ? primaryClasses : ''} ${outline ? outlineClasses : ''} ${className}`;

  return to ? (
    <Link
      to={to}
      smooth={true}
      className={classes}
      {...props}
    >
      {children}
    </Link>
  ) : (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;